module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"toDo":"To do","noTaskToDo":"No tasks to do.","buttons":{"markAsALeaver":"Mark as a leaver"}}}}')
  delete Component.options._Ctor
}
